/**
 * GpsIndicator
 *
 * Zeigt an, wenn der Standort ermittelt wird (z.B. beim Tagesabschluss).
 * Wird nur sichtbar, wenn isCapturingLocation true ist.
 */

import { MapPin } from 'lucide-preact';
import { isCapturingLocation } from '../../stores/timesheet.store';
import styles from './GpsIndicator.module.css';

export function GpsIndicator() {
  if (!isCapturingLocation.value) {
    return null;
  }

  return (
    <div className={styles.indicator}>
      <MapPin size={16} className={styles.pulseIcon} />
      <span>Standort wird ermittelt...</span>
    </div>
  );
}
